import { action, observable } from 'mobx';
import { api } from '../config';

// Components
import SessionStore from './SessionStore';

let obx = observable({
  cancellationPolicies: [],
  // Get cancellation policies
  getCancellationPolicies: action(function() {
    SessionStore.startLoading('Loading…', 'getCancellationPolicies');

    obx.courseRoster = [];

    api.get(`/proctors/${SessionStore.userData.proctorAccountSid}/cancellationPolicies`)
      .then(response => {
        obx.cancellationPolicies = response.data.results;
        SessionStore.finishLoading('getCancellationPolicies');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Initialize a new cancellation policy
  initCancellationPolicy: action(function() {
    const newPolicy = {
      title: 'New Cancellation Policy',
      dateRange: false,
      effectiveDate: null,
      expirationDate: null,
      sid: Date.now(),
      versions: [{
        title: 'New Cancellation Policy',
        effectiveDate: null,
        expirationDate: null,
        notes: '',
        rules: [{
          minutesPrior: null,
          penaltyPercentage: 0
        }],
        status: 'enabled'
      }]
    }

    obx.cancellationPolicies.push(newPolicy);
  }),
  // Create cancellation policy
  createCancellationPolicy: action(function(policy) {
    SessionStore.startLoading('Loading…', 'createCancellationPolicy');

    if(!policy.effectiveDate) {
      policy.effectiveDate = '2000-01-01T05:00:00.000Z';
    }

    if(!policy.expirationDate) {
      policy.expirationDate = '2070-01-01T05:00:00.000Z';
    }

    // Remove any empty properties
    Object.keys(policy).forEach(property => {
      if(!policy[property]) {
        delete policy[property];
      }
    });

    api.post(`/proctors/${SessionStore.userData.proctorAccountSid}/cancellationPolicies`, policy)
      .then(response => {
        SessionStore.finishLoading('createCancellationPolicy');
        obx.getCancellationPolicies();
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Update cancellation policy
  updateCancellationPolicy: action(function(policy) {
    SessionStore.startLoading('Loading…', 'updateCancellationPolicy');

    if(!policy.effectiveDate) {
      policy.effectiveDate = '2000-01-01T05:00:00.000Z';
    }

    if(!policy.expirationDate) {
      policy.expirationDate = '2070-01-01T05:00:00.000Z';
    }

    // API returns status as uppercase, but only accepts lowercase…
    policy.status = policy.status.toLowerCase();

    // Remove any empty properties
    Object.keys(policy).forEach(property => {
      if(!policy[property]) {
        delete policy[property];
      }
    });

    api.put(`/proctors/${SessionStore.userData.proctorAccountSid}/cancellationPolicies/${policy.sid}`, policy)
      .then(response => {
        SessionStore.finishLoading('updateCancellationPolicy');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Delete cancellation policy
  deleteCancellationPolicy: action(function(policySid) {
    SessionStore.startLoading('Loading…', 'deleteCancellationPolicy');

    api.delete(`/proctors/${SessionStore.userData.proctorAccountSid}/cancellationPolicies/${policySid}`)
      .then(response => {
        SessionStore.finishLoading('deleteCancellationPolicy');
        obx.getCancellationPolicies();
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  })
});

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/PolicyStore.js